import { Component } from "react"

/* Redux */
import { connect } from "react-redux"

/* Components */
import { Layout, Input } from "../../components"

/* REST API */
import { get, edit } from "../../api/Operator"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* Helpers */
import { utils, withRouter } from "../../helpers"

/* Swal */
import Swal from "sweetalert2"

/* Translate */
import { t } from "../../translates/translate"



/* Page Operator Edit */
class OperatorEdit extends Component {

    constructor() {
        super()

        this.state = {
            status: "loading",
            name: "",
            slug: "",
            token: "",
            startpoint: "",
            balanceURL: "",
            debitURL: "",
            creditURL: "",
            webhookURL: "",
            roundCloseURL: "",
            waiting: false,
        }
    }

    componentDidMount = () => {
        this.load()
    }

    /* Load */
    load = (reload = false) => {

        const { params } = this.props
        const { id } = params

        if (id) {

            if (reload) {
                this.setState({ status: "loading" })
            }

            get({ id }).then((response) => {
                if (response.status === 200) {
                    const data = response.data
                    this.setState({
                        status: "ok",
                        token: utils.checkValue(data.operator.token),
                        name: utils.checkValue(data.operator.name),
                        slug: utils.checkValue(data.operator.slug),
                        startpoint: utils.checkValue(data.operator.startpoint),
                        balanceURL: utils.checkValue(data.operator.balanceURL),
                        debitURL: utils.checkValue(data.operator.debitURL),
                        creditURL: utils.checkValue(data.operator.creditURL),
                        webhookURL: utils.checkValue(data.operator.webhookURL),
                        roundCloseURL: utils.checkValue(data.operator.roundCloseURL),
                    })
                }
                else if (response.status === 401 || response.status === 403) {
                    this.setState({ status: "permission" })
                }
                else if (response.status === 498) {
                    this.setState({ status: "key" })
                }
                else {
                    this.setState({ status: "error" })
                }
            }).catch(() => {
                this.setState({ status: "network" })
            })

        }
        else {
            this.setState({ status: "error" })
        }

    }

    /* Save action */
    save = () => {

        const { name, slug, startpoint, balanceURL, debitURL, creditURL, webhookURL, roundCloseURL } = this.state
        const { navigate, params } = this.props
        const { id } = params

        if (!id) {
            Swal.fire(utils.notification(t("swal.generic"), "error"))
            return
        }

        if (name === "" || name === null || name === undefined) {
            this._name.error(t("operator.error.emptyName"))
            return
        }

        if (slug === "" || slug === null || slug === undefined) {
            this._slug.error(t("operator.error.emptySlugAlt"))
            return
        }

        if (startpoint === "" || startpoint === null || slug === startpoint) {
            this._startpoint.error(t("operator.error.emptyStartpoint"))
            return
        }

        if (balanceURL === "" || balanceURL === null || slug === balanceURL) {
            this._balance.error(t("operator.error.emptyBalance"))
            return
        }

        if (debitURL === "" || debitURL === null || slug === debitURL) {
            this._debit.error(t("operator.error.emptyDebit"))
            return
        }

        if (creditURL === "" || creditURL === null || slug === creditURL) {
            this._balance.error(t("operator.error.emptyCredit"))
            return
        }

        if (webhookURL === "" || webhookURL === null || slug === webhookURL) {
            this._webhook.error(t("operator.error.emptyWebhook"))
            return
        }

        this.setState({ waiting: true })

        edit({ id, name, slug, startpoint, balanceURL, debitURL, creditURL, webhookURL, roundCloseURL }).then((response) => {
            if (response.status === 200) {
                Swal.fire(utils.notification(t("operator.savedSuccess"), "success")).then(() => {
                    navigate(-1)
                })
            }
            else if (response.status === 401 || response.status === 403) {
                Swal.fire(utils.notification(t("swal.noAccess"), "error"))
            }
            else if (response.status === 498) {
                Swal.fire(utils.notification(t("swal.invalidKey"), "error"))
            }
            else {
                Swal.fire(utils.notification(t("swal.generic"), "error"))
            }
        }).catch(() => {
            Swal.fire(utils.notification(t("swal.generic"), "error"))
        }).finally(() => {
            this.setState({ waiting: false })
        })


    }

    /* Draw button */
    _button = () => {

        const { waiting } = this.state

        if (waiting) {
            return <div className="button"><LoadingOutlined /></div>
        }

        return <div onClick={() => this.save()} className="button">{t("common.save")}</div>
    }

    render = () => {

        const { status, name, slug, token, startpoint, balanceURL, debitURL, creditURL, webhookURL, roundCloseURL } = this.state

        if (status !== "ok") {
            return <Layout status={status} reload={() => this.load(true)} />
        }

        return (
            <div className="page">

                <div className="page-header">
                    <h1>{t("operator.editTitle")}</h1>
                </div>

                <div className="page-form">

                    <div className="form">
                        <div className="form-box">
                            <Input ref={(ref) => this._name = ref} label={t("operator.name")} value={name} onChange={(event) => this.setState({ name: event.target.value })} />
                            <Input ref={(ref) => this._slug = ref} label="Slug" value={slug} onChange={(event) => this.setState({ slug: event.target.value })} />
                            <Input disabled label="Token" value={token} />
                            <Input ref={(ref) => this._startpoint = ref} label="Startpoint" value={startpoint} onChange={(event) => this.setState({ startpoint: event.target.value })} />
                            <Input ref={(ref) => this._balance = ref} label="Balance url" value={balanceURL} onChange={(event) => this.setState({ balanceURL: event.target.value })} />
                            <Input ref={(ref) => this._debit = ref} label="Debit url" value={debitURL} onChange={(event) => this.setState({ debitURL: event.target.value })} />
                            <Input ref={(ref) => this._credit = ref} label="Credit url" value={creditURL} onChange={(event) => this.setState({ creditURL: event.target.value })} />
                            <Input ref={(ref) => this._webhook = ref} label="Webhook url" value={webhookURL} onChange={(event) => this.setState({ webhookURL: event.target.value })} />
                            <Input ref={(ref) => this._roundClose = ref} label="Round close url" value={roundCloseURL} onChange={(event) => this.setState({ roundCloseURL: event.target.value })} />
                        </div>
                    </div>

                    <div className="form-bottom">
                        {this._button()}
                    </div>

                </div>

            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps)(withRouter(OperatorEdit))
